module.exports = __webpack_public_path__ + "img/wallpaper.4cfdbb7b.png";